export const terms = [
	'Making orders from the site is complete, live register to use communications you must pass.',
	'This is why you cannot cancel your orders once you have paid for them check before making payments.',
	'It is not possible to write and distribute personal ads without the permission of the admin.',
	'All your actions are under the control of our store administration, so please follow the general rules.',
];
